/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import {useNavigate, useParams} from "react-router-dom"; // Import hook to navigate to different routes
import {useEffect, useRef, useState} from "react"; // Import React hooks for state management and lifecycle methods
import TableFunction from "../../../../components/table/TableFunction";
import {GetVehicleOnContractById} from "../../../../reduxToolkit/Contractor/ContractorApi";
import {useDispatch, useSelector} from "react-redux";
import {VIEW_TYPE} from "../../../../enums/ViewType";
import {SIMPLE_PAGINATION_MODEL} from "../../../../components/table/Model/TableModel"; // Import toast notifications for UI feedback
import ButtonActionsCard from "../../../../components/buttons/ButtonActionsCard";
import { ArrowRightIcon } from "../../../../components/buttons/IconButtons";
import routes from "../../../../Routes/routes";
import {USER_TYPE_NAME_MODEL} from "../../../../enums/userTypeEnum";
import { permissionObj } from '../../../../Helpers/permission';

// Component to display contract vehicle details
const ContractVehicleDetailsCardsApp = ({
    selectedList,
    setSelectedList,
    modified,
    setModified,
    isAllChecked,
    setIsAllChecked,
    subView,
    contractorId
}) => {
    const dispatch = useDispatch(); // Redux dispatch hook
    const {contractId} = useParams();
    const navigate = useNavigate(); // Initialize navigation hook for routing
    const elementRefTab1 = useRef(null); // Create a reference to a DOM element for tab positioning
    const [results, setResults] = useState({content:[], totalElements:0}); // State to store the vehicle data and pagination info
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const { user } = useSelector((state) => state.authenticatioauthennSlice);
    const userType = user?.data?.userType?.name;
    // Contractors manage their own contract, employees need the update and manage vehicles permissions to select and remove
    const canSelect =
        Boolean(contractorId) ||
        DEV ||
        permission?.includes(permissionObj.WEB_CONTRACTOR_CONTRACT_MANAGE_VEHICLES);

    // useLayoutEffect hook to calculate the position of the element for dynamic styling
    useEffect(() => {
        if (elementRefTab1.current) {
            const rect = elementRefTab1.current.getBoundingClientRect(); // Get the position of the element in the viewport
            const distanceTop = rect.top + 20; // Calculate the distance from the top
            elementRefTab1.current.style.setProperty('--top-value', `${distanceTop}px`); // Apply the top position to the element's custom property
        }
    }, [results]);

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = async (page) => {
        dispatch(GetVehicleOnContractById({ id: contractId, contractPagination: SIMPLE_PAGINATION_MODEL.set({ page, rowsPerPage}) }))
            .then(({payload:{data:{data, success}}}) => {
            if(success){
                setResults(data); // Set the results with the data from the response
            }
        });
    };

    const {t, handleCheckboxChange, handleDeleteAll,
        pagination, rowsPerPage} = TableFunction({
        selectedList,
        setSelectedList,
        data:results,
        fixedPagination:false,
        hasContainer:true,
        labelRowsPerPage:'vehicles_per_page',
        setIsAllChecked,
        view:VIEW_TYPE.GRID.name,
        getData,//New
        modified,//New
        setModified//New
    });

 const renderVehicleButton = (character) => {
     let go;
     let back;
     if(userType === USER_TYPE_NAME_MODEL.EMPLOYEE){
         go =  routes.employee.contractorVehicleDetails + character?.id;
         back =  routes.employee.contractDetails + contractId;
     } else {
         go= routes.vehicleContractor.details + character?.id;
         back = routes.contractor.contractDetails + contractId;
     }

     return (
         <div className='d-flex justify-content-end align-items-start gap-2 stretch-self w-100'>
             <ButtonActionsCard
                 id={'btn_cvdc_actions_card'}
                 name={'details'}
                 Icon={ArrowRightIcon}
                 onClick={() => navigate(go, { state: { backUrl: back, currentSubView: subView }})}
             />
         </div>
     );
 };
    // Return values and functions for the component to be used in the UI
    return {
        t, // Translation function for localization
        contractId,
        DEV,
        permission,
        navigate, // Navigation function for routing
        elementRefTab1, // Reference to the DOM element for positioning
        results, // The results data to display
        isAllChecked,
        pagination, // Pagination component
        handleCheckboxChange, // Checkbox change handler
        handleDeleteAll,
        renderVehicleButton,
        canSelect,
    };
};

export default ContractVehicleDetailsCardsApp; // Export the component to be used in other parts of the app
